// extracted by mini-css-extract-plugin
export var active = "users-affirmations-module--active--3444b";
export var bgAffirmation = "users-affirmations-module--bg-affirmation--94894";
export var btnPagination = "users-affirmations-module--btn-pagination--2ee5a";
export var listAffirmation = "users-affirmations-module--list-affirmation--ffebf";